// import React from 'react';
// import { TabletSmartphone, Fingerprint, X } from 'lucide-react';

// const EnrollDeviceModal = ({
//   isOpen,
//   onClose,
//   onSubmit,
//   user,
//   devices,
//   selectedDeviceId,
//   setSelectedDeviceId,
//   errors,
//   isEnrolling
// }) => {
//   if (!isOpen || !user) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm" onClick={onClose}>
//       <div className="w-full border sm:max-w-md bg-richblue-950 border-blue-700/50 rounded-2xl sm:rounded-2xl sm:mb-0 mb-[170px]" onClick={(e) => e.stopPropagation()}>
//         <div className="flex items-center justify-between p-5 border-b border-blue-800/40">
//           <h2 className="flex items-center gap-2 text-lg font-bold text-white">
//             <TabletSmartphone className="w-5 h-5 text-blue-300" /> Select Device
//           </h2>
//           <button onClick={onClose} className="p-2 transition-colors rounded-lg hover:bg-blue-600/20">
//             <X className="w-5 h-5 text-blue-400" />
//           </button>
//         </div>

//         <form onSubmit={onSubmit} className="p-5 space-y-4">
//           <div className="flex items-center gap-3 px-4 py-3 border bg-richblue-900 border-blue-800/40 rounded-xl">
//             <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//               {user.user_name?.charAt(0)}
//             </div>
//             <div>
//               <p className="text-sm font-medium text-white">{user.user_name}</p>
//               <p className="text-xs text-blue-400/60">{user.user_roll}</p>
//             </div>
//           </div>

//           <div>
//             <label className="block mb-2 text-sm font-medium text-blue-300">Select Device *</label>
//             <select
//               value={selectedDeviceId}
//               onChange={(e) => {
//                 setSelectedDeviceId(e.target.value);
//                 // Clear error when user selects a device
//               }}
//               className={`w-full px-4 py-2.5 text-white border rounded-lg bg-richblue-900 focus:outline-none focus:ring-2 focus:ring-blue-600/70 ${
//                 errors.device ? 'border-red-500' : 'border-blue-800/60'
//               }`}
//             >
//               <option value="">-- Select a device --</option>
//               {devices.length > 0 ? (
//                 devices.map(device => (
//                   <option key={device._id} value={device._id}>
//                     {device.device_name} ({device.device_code}) - {device.device_location}
//                   </option>
//                 ))
//               ) : (
//                 <option value="" disabled>No available devices</option>
//               )}
//             </select>
//             {errors.device && <p className="mt-1 text-xs text-red-400">{errors.device}</p>}
//           </div>

//           <div className="flex gap-3 pt-1">
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 px-4 py-2.5 rounded-lg border border-blue-800/60 text-blue-300 hover:bg-blue-800/20 transition-colors text-sm font-medium"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={!selectedDeviceId || isEnrolling}
//               className="flex-1 px-4 py-2.5 rounded-lg bg-green-600 hover:bg-green-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2"
//             >
//               <Fingerprint className="w-4 h-4" /> Start Enrollment
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EnrollDeviceModal;


import React from 'react';
import { TabletSmartphone, Fingerprint, X } from 'lucide-react';

const EnrollDeviceModal = ({
  isOpen,
  onClose,
  onSubmit,
  user,
  devices,
  selectedDeviceId,
  setSelectedDeviceId,
  errors,
  isEnrolling,
  theme
}) => {
  if (!isOpen || !user) return null;

  const isDark = theme === 'dark';

  // Theme-aware classes
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgUserCard = isDark ? 'bg-richblue-900' : 'bg-gray-50';
  const bgSelect = isDark ? 'bg-richblue-900' : 'bg-white';
  
  const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
  const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
  const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
  const borderError = isDark ? 'border-red-500' : 'border-red-400';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
  const textMuted = isDark ? 'text-blue-400/60' : 'text-gray-500';
  //const textBlue = isDark ? 'text-blue-300' : 'text-blue-600';
  
  const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
  const buttonCancel = isDark 
    ? 'border-blue-800/60 text-blue-300 hover:bg-blue-800/20'
    : 'border-gray-300 text-gray-700 hover:bg-gray-100';
  
  const buttonSubmit = isDark
    ? 'bg-green-600 hover:bg-green-500'
    : 'bg-green-600 hover:bg-green-700';

  return (
    <div className={`fixed inset-0 z-50 flex items-end justify-center p-0 sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`} onClick={onClose}>
      <div className={`w-full border sm:max-w-md ${bgModal} ${borderColor} rounded-2xl sm:rounded-2xl sm:mb-0 mb-[170px] transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
        <div className={`flex items-center justify-between p-5 border-b ${bgHeader} ${borderLight}`}>
          <h2 className={`flex items-center gap-2 text-lg font-bold ${textPrimary}`}>
            <TabletSmartphone className="w-5 h-5 text-blue-300" /> Select Device
          </h2>
          <button onClick={onClose} className={`p-2 transition-colors rounded-lg ${hoverBg}`}>
            <X className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-500'}`} />
          </button>
        </div>

        <form onSubmit={onSubmit} className="p-5 space-y-4">
          <div className={`flex items-center gap-3 px-4 py-3 border ${bgUserCard} ${borderInput} rounded-xl transition-colors duration-300`}>
            <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
              {user.user_name?.charAt(0)}
            </div>
            <div>
              <p className={`text-sm font-medium ${textPrimary}`}>{user.user_name}</p>
              <p className={`text-xs ${textMuted}`}>{user.user_roll}</p>
            </div>
          </div>

          <div>
            <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Select Device *</label>
            <select
              value={selectedDeviceId}
              onChange={(e) => {
                setSelectedDeviceId(e.target.value);
              }}
              className={`w-full px-4 py-2.5 ${textPrimary} ${bgSelect} border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600/70 ${
                errors.device ? borderError : borderInput
              } transition-colors duration-300`}
            >
              <option value="">-- Select a device --</option>
              {devices.length > 0 ? (
                devices.map(device => (
                  <option key={device._id} value={device._id} className={isDark ? 'bg-richblue-950' : 'bg-white'}>
                    {device.device_name} ({device.device_code}) - {device.device_location}
                  </option>
                ))
              ) : (
                <option value="" disabled>No available devices</option>
              )}
            </select>
            {errors.device && <p className="mt-1 text-xs text-red-400">{errors.device}</p>}
          </div>

          <div className="flex gap-3 pt-1">
            <button
              type="button"
              onClick={onClose}
              className={`flex-1 px-4 py-2.5 rounded-lg border ${buttonCancel} transition-colors text-sm font-medium`}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!selectedDeviceId || isEnrolling}
              className={`flex-1 px-4 py-2.5 rounded-lg ${buttonSubmit} disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2`}
            >
              <Fingerprint className="w-4 h-4" /> Start Enrollment
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EnrollDeviceModal;
